/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".kit-model-code[_ngcontent-%COMP%]{font-size:20px;line-height:20px;margin-bottom:0;text-transform:uppercase}.kit-model-phy-info[_ngcontent-%COMP%]{font-size:18px;line-height:20px;margin-bottom:0;margin-top:5px}@media (min-width:992px){.kit-model-phy-info[_ngcontent-%COMP%]{margin-top:0}}.box-kit-model-container[_ngcontent-%COMP%]{width:100%;padding:12px 0;display:flex;flex-direction:row;justify-content:space-between}@media (min-width:768px){.box-kit-model-container[_ngcontent-%COMP%]{padding:12px 20px}}"];
export { styles as styles };
